import { Injectable } from "@angular/core";
import { FieldTypes } from "@tmhcc-ng-lib/framwork/form-inputs";
import { Validators } from "@angular/forms";
import { CommonContentService } from "@tmhcc/content-service";
import { BsDatepickerDirective } from "ngx-bootstrap/datepicker";
import { DateService } from "@tmhcc-ng-lib/framwork/services";
@Injectable()
export class WeatherRatingSetupService {
  constructor(private dateService: DateService) { }
  weatherRatingConfig() {
    return {
      weatherRatingConfigList: [
        {
          fieldInfo: {
            fieldName: "eventName",
            label: "Event Name",
            fieldType: FieldTypes.TextCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required]
          }
        },
        {
          fieldInfo: {
            fieldName: "venuename",
            label: "Venue Name",
            fieldType: FieldTypes.TextCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
          }
        },
        {
          fieldInfo: {
            fieldName: "streetaddress",
            label: "Street Address",
            fieldType: FieldTypes.TextCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
          }
        },
        {
          fieldInfo: {
            fieldName: "city",
            label: "City",
            fieldType: FieldTypes.TextCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
          }
        },
        {
          fieldInfo: {
            fieldName: "state",
            label: "State",
            fieldType: FieldTypes.LookupListCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            validation: [Validators.required],
            selectConfig: {
              selectedOption: [],
              options: ["AL",
              "AK",
              "AZ",
              "AR",
              "CA",
              "CO",
              "CT",
              "DE",
              "FL",
              "GA",
              "HI",
              "ID",
              "IL",
              "IN",
              "IA",
              "KS",
              "KY",
              "LA",
              "ME",
              "MD",
              "MA",
              "MI",
              "MN",
              "MS",
              "MO",
              "MT",
              "NE",
              "NV",
              "NH",
              "NJ",
              "NM",
              "NY",
              "NC",
              "ND",
              "OH",
              "OK",
              "OR",
              "PA",
              "RI",
              "SC",
              "SD",
              "TN",
              "TX",
              "UT",
              "VT",
              "VA",
              "WA",
              "WV",
              "WI",
              "WY",
              "DC"],
              optionConfig: {
                displayKey: "description",
                search: true,
                limitTo: 3
              },
              multiple: false
            }
          }
        },
        {
          fieldInfo: {
            fieldName: "zipcode",
            label: "Zip Code",
            fieldType: FieldTypes.NumberCustom,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
          }
        },
        {
          config: {
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4,
            validation: [Validators.required]
          },
          fieldInfo: {
            fieldName: "eventstartdate0",
            label: "Event Start",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: true,
            value:null,
            validation: {
              required: "Required",
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4,
            validation: [Validators.required]
          },
          fieldInfo: {
            fieldName: "eventenddate0",
            label: "Event End:",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: true,
            value:null,              
            validation: {
              required: "Required",
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {
            fieldName: "eventstartdate1",
            label: "Event Start",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {
            fieldName: "eventenddate1",
            label: "Event End:",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,              
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {
            fieldName: "eventstartdate2",
            label: "Event Start",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {            
            fieldName: "eventenddate2",
            label: "Event End:",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,              
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        }, //---new
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {
            fieldName: "eventstartdate3",
            label: "Event Start",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {            
            fieldName: "eventenddate3",
            label: "Event End:",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,              
            validation: {              
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {
            fieldName: "eventstartdate4",
            label: "Event Start",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,
            validation: {             
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        },
        {
          config: {
            isHidden:true,
            value:
              this.dateService.toShortDate(
                this.dateService.moment(
                  new Date().toISOString()
                )
              ),
            datePickerConfig: {
              dateInputFormat: this.dateService.getLongFormat(),
              isCalanderRequired: true,
              showWeekNumbers: false,
              // minDate: this.mindate,
              outSideClick: false,
              adaptivePosition: false,
              isAnimated: true,
              placement: "top",
              container: "body"
            },
            optionField: 4            
          },
          fieldInfo: {            
            fieldName: "eventenddate4",
            label: "Event End:",
            decimal: 0,
            fieldType: FieldTypes.DateCustom,
            showLabel: true,
            required: false,
            value:null,              
            validation: {
              required: "Required",
              pastDate: "Date Passed",
              invalidDate: "Invalid Date"
            }
          },
          colClass: "col-md-6 col-lg-3"
        }
      ]
    }
    //---
  };
  ThresholdConfig() {
    return {
      ThresholdConfigList: [
        {
          fieldInfo: {
            fieldName: "threshold1",
            label: "Threshold",
            fieldType: FieldTypes.Numeric,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
            isHidden:false
          }
        },
        {
          fieldInfo: {
            fieldName: "threshold2",
            label: "Threshold",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true            
          }
        },
        {
          fieldInfo: {
            fieldName: "threshold3",
            label: "Threshold",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true            
          }
        },
        {
          fieldInfo: {
            fieldName: "threshold4",
            label: "Threshold",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true            
          }
        },
        {
          fieldInfo: {
            fieldName: "threshold5",
            label: "Threshold",
            fieldType: FieldTypes.Numeric,
            showLabel: false           
          },
          config: {
            isDisabled: false,
            isHidden:true           
          }
        }]
    }
  }
  LimitConfig() {
    return {
      LimitConfigList: [
        {
          fieldInfo: {
            fieldName: "limit1",
            label: "Limit",
            fieldType: FieldTypes.Numeric,
            showLabel: true,
            validation: {
              required: "Required"
            }
          },
          config: {
            isDisabled: false,
            validation: [Validators.required],
            isHidden:false,
            numericConfig: {
            type: "currency"
           }
          }
        },
        {
          fieldInfo: {
            fieldName: "limit2",
            label: "Limit",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true,
            numericConfig: {
            type: "currency"
           }            
          }
        },
        {
          fieldInfo: {
            fieldName: "limit3",
            label: "Limit",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true,
            numericConfig: {
            type: "currency"
           }            
          }
        },
        {
          fieldInfo: {
            fieldName: "limit4",
            label: "Limit",
            fieldType: FieldTypes.Numeric,
            showLabel: false            
          },
          config: {
            isDisabled: false,
            isHidden:true,
            numericConfig: {
            type: "currency"
           }            
          }
        },
        {
          fieldInfo: {
            fieldName: "limit5",
            label: "Limit",
            fieldType: FieldTypes.Numeric,
            showLabel: false           
          },
          config: {
            isDisabled: false,
            isHidden:true,
            numericConfig: {
            type: "currency"
           }           
          }
      }]
    }
  }
}